import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  // Usamos BehaviorSubject para controlar el estado de carga del spinner
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();  // Observable que emite cambios en el estado de carga

  // Método para mostrar el spinner
  show(): void {
    this.loadingSubject.next(true);
  }

  // Método para ocultar el spinner
  hide(): void {
    this.loadingSubject.next(false);
  }
}